import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
@keyframes genie-open {
  0% {
    opacity: 0;
    transform: scale(0) translateY(50%) translateX(50%);
    transform-origin: bottom right;
  }
  50% {
    opacity: 1;
    transform: scale(1.1) translateY(0) translateX(0);
  }
  100% {
    transform: scale(1) translateY(0) translateX(0);
  }
}
@keyframes genie-close {
  0% {
    transform: scale(1) translateY(0) translateX(0);
    opacity: 1;
  }
  50% {
    transform: scale(1.1) translateY(0) translateX(0);
    opacity: 0.5;
  }
  100% {
    opacity: 0;
    transform: scale(0) translateY(50%) translateX(50%);
    transform-origin: bottom right;
  }
}
.animate-genie-open {
  animation: genie-open 0.5s ease-in-out forwards;
}

.animate-genie-close {
  animation: genie-close 0.5s ease-in-out forwards;
}

@keyframes wiggle {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(3deg);
  }
  50% {
    transform: rotate(-3deg);
  }
  75% {
    transform: rotate(3deg);
  }
}
.animate-wiggle {
  animation: wiggle 0.4s ease-in-out 1;
}`],
})
export class PageMainComponent implements OnInit {

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }
}

export default PageMainComponent;